import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ScrollEnablerDirective } from '../../../cross-team-shared/scroll-enabler.directive';

@Component({
  selector: 'h3-scrollable-list',
  templateUrl: './scrollable-list.component.html',
  styleUrls: ['./scrollable-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  hostDirectives: [ScrollEnablerDirective],
})
export class ScrollableListComponent {}
